import Logout from "./Logout";
// import Login from './Login';

const modals = {
  Logout,
  //   Login,
};

export default modals;
